if (!customElements.get('read-more-text')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.style.display = 'block';
      this.style.overflow = 'hidden';
      this.style.transition = 'max-height 1s ease-in-out';
      this.style.maxHeight = `${this.scrollHeight}px`;
      this.fullHeight = `${this.scrollHeight + 500 }px`;

      this.limit = this.dataset.limit || 350;
      this.fullText = this.innerHTML;
      this.shortText = this.fullText.substring(0, this.limit);
      this.shortText = this.shortText.substring(0, Math.min(this.shortText.length, this.shortText.lastIndexOf(" ")));

      this.toggleReadMore(this, true);
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        this.toggleReadMore(this);
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.style.maxHeight = `${this.scrollHeight}px`;
        }, 250);
      });
    }

    toggleReadMore(element, init = false) {
      // limit text to 350 character and add read more link
      const more = '... <a href="#" class="text-[#5a5a5a] underline" data-read-more-toggle>Read More</a>';
      const less = ' <a href="#" class="text-[#5a5a5a] underline" data-read-more-toggle>Read Less</a>';
      const newText = this.shortText + more;

      // init
      if ((this.fullText.length > this.limit) && init) {
        this.innerHTML = newText;
        this.style.maxHeight = `${this.scrollHeight}px`;
      }

      // toggle read more link
      var readMoreLink = element.querySelector('[data-read-more-toggle]');
      readMoreLink.addEventListener('click', () => {
        this.innerHTML = (readMoreLink.innerHTML == 'Read More') ? this.fullText + less : this.innerHTML = newText
        this.style.maxHeight = (readMoreLink.innerHTML == 'Read More') ? (this.fullHeight) :  this.scrollHeight + 'px';
      });
    }
  }
  customElements.define('read-more-text', ReadMore);
}
